// src/icons/svgs/audio-object.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgAudioObject = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, fill: "none", "data-directional": "true", viewBox: "0 0 24 25", ref, ...props, children: /* @__PURE__ */ jsx("path", { stroke: "#495057", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.33, d: "m11 5.5-5 4H2v6h4l5 4zM19.07 5.43a10 10 0 0 1 0 14.14M15.54 8.96a5 5 0 0 1 0 7.07" }) });
var ForwardRef = forwardRef(SvgAudioObject);
var audio_object_default = ForwardRef;
export {
  audio_object_default as AudioObject
};
